import { z } from "zod";
import { Wilayas } from "@/lib/wilayas";

export const machineSchema = z.object({
  name: z.string().min(1, "Name is required"),
  size: z.enum(["86", "65"], {
    required_error: "Size is required",
    invalid_type_error: "Please select a valid size",
  }),
  wilaya: z
    .string()
    .min(1, "Wilaya is required")
    .refine((val) => Wilayas.includes(val), {
      message: "Please select a valid wilaya",
    }),
  isActive: z.boolean().default(true),
  ip_whitelist: z
    .array(
      z.string().refine(
        (val) => {
          // Allow empty strings (they'll be filtered out before submission)
          if (!val || val.trim() === "") return true;
          // Validate IPv4 format for non-empty strings
          const ipv4Regex =
            /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
          return ipv4Regex.test(val.trim());
        },
        {
          message: "Please enter a valid IPv4 address",
        }
      )
    )
    .optional()
    .default([]),
});

export const createMachineSchema = machineSchema;
export const updateMachineSchema = machineSchema;
